import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Filter = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.022 1.37195C14.5743 1.37195 15.022 1.81966 15.022 2.37195V3.37195H21.022C21.5743 3.37195 22.022 3.81966 22.022 4.37195C22.022 4.92423 21.5743 5.37195 21.022 5.37195H15.022V6.37195C15.022 6.92423 14.5743 7.37195 14.022 7.37195C13.4697 7.37195 13.022 6.92423 13.022 6.37195V2.37195C13.022 1.81966 13.4697 1.37195 14.022 1.37195ZM2.02197 4.37195C2.02197 3.81966 2.46969 3.37195 3.02197 3.37195H10.022C10.5743 3.37195 11.022 3.81966 11.022 4.37195C11.022 4.92423 10.5743 5.37195 10.022 5.37195H3.02197C2.46969 5.37195 2.02197 4.92423 2.02197 4.37195ZM8.02197 9.37195C8.57426 9.37195 9.02197 9.81966 9.02197 10.3719V14.3719C9.02197 14.9242 8.57426 15.3719 8.02197 15.3719C7.46969 15.3719 7.02197 14.9242 7.02197 14.3719V13.3719H3.02197C2.46969 13.3719 2.02197 12.9242 2.02197 12.3719C2.02197 11.8197 2.46969 11.3719 3.02197 11.3719H7.02197V10.3719C7.02197 9.81966 7.46969 9.37195 8.02197 9.37195ZM11.022 12.3719C11.022 11.8197 11.4697 11.3719 12.022 11.3719H21.022C21.5743 11.3719 22.022 11.8197 22.022 12.3719C22.022 12.9242 21.5743 13.3719 21.022 13.3719H12.022C11.4697 13.3719 11.022 12.9242 11.022 12.3719ZM16.022 17.3719C16.5743 17.3719 17.022 17.8197 17.022 18.3719V19.3719H21.022C21.5743 19.3719 22.022 19.8197 22.022 20.3719C22.022 20.9242 21.5743 21.3719 21.022 21.3719H17.022V22.3719C17.022 22.9242 16.5743 23.3719 16.022 23.3719C15.4697 23.3719 15.022 22.9242 15.022 22.3719V18.3719C15.022 17.8197 15.4697 17.3719 16.022 17.3719ZM2.02197 20.3719C2.02197 19.8197 2.46969 19.3719 3.02197 19.3719H12.022C12.5743 19.3719 13.022 19.8197 13.022 20.3719C13.022 20.9242 12.5743 21.3719 12.022 21.3719H3.02197C2.46969 21.3719 2.02197 20.9242 2.02197 20.3719Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};

export default Filter;
